import { render, staticRenderFns } from "./adminlogin.vue?vue&type=template&id=0cc2484e&scoped=true"
import script from "./adminlogin.vue?vue&type=script&lang=js"
export * from "./adminlogin.vue?vue&type=script&lang=js"
import style0 from "./adminlogin.vue?vue&type=style&index=0&id=0cc2484e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2484e",
  null
  
)

export default component.exports